<style scoped="scoped" lang="scss"></style>

<template>
  <div style="width: 100%;background: linear-gradient(179.76deg, #EDF6FF 0.21%, rgba(227, 241, 255, 0.35) 99.8%), #FFFFFF;display: flex;flex-direction: column;" :style="{ height: height }">
    <Yi_card_reader ref="cardReader" @cardReaded="cardReaded"></Yi_card_reader>
    <div ref="header" class="header" style="height: 48px;background: white;box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);display: flex;justify-content: space-between;align-items: center;">
      <img style="width: 98px;height:22px;margin-left: 24px;" src="../../../assets/img/account/logo.png" />
      <div style="display: flex;align-items: center;">
        <div style="margin-right: 36px;">
          <el-dropdown style="color: #606266;cursor: pointer;" trigger="click" @command="changeLocale">
            <span class="el-dropdown-link">
              <i class="yicon yicon-language" style="margin-right: 4px;"></i>
              {{ { zh_CN: $t("zhongwen"), en_US: $t("yingwen"), de_DE: $t("deyu") }[lang] }}
              <i class="yicon yicon-arrow_down" style="margin-left: 4px;"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">{{ $t("zhongwen") }}</el-dropdown-item>
              <el-dropdown-item command="1">{{ $t("yingwen") }}</el-dropdown-item>
              <el-dropdown-item command="2">{{ $t("deyu") }}</el-dropdown-item>
              <!-- <el-dropdown-item command="3">{{ $t('alaboyu') }}</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div style="margin-right: 36px;">
          <el-button style="color: #606266;" type="text" @click.native="toggleFullScreen()"> <i v-show="!isFullscreen" class="yicon yicon-fullscreen" style="margin-right: 4px;"></i><i v-show="isFullscreen" class="yicon yicon-normal_screen" style="margin-right: 4px;"></i>{{ $t("quanping") }} </el-button>
        </div>
      </div>
    </div>
    <div class="content" style="position: relative;width: 100%;display: flex;justify-content: space-around;align-items: center;flex: 1;overflow: hidden;" :style="{ height: contentHeight }">
      <img style="position: absolute;width: 100%;bottom: 0;top: 0;" src="../../../assets/img/account/bg.png" />
      <div style="display:flex;z-index:1;border-radius: 10px;overflow: hidden;;">
        <img style="width: auto;height:530px;" src="../../../assets/img/account/card.png" />
        <div style="flex-shrink: 0;position: relative;width: 400px;height: 530px;background: white;z-index: 2;box-sizing: border-box;;display: flex;flex-direction: column;align-items: center;">
          <div v-show="!isQr" style="width: 280px;">
            <img style="width: 88px;position: absolute;z-index: -1;height:88px;right: 5px;top: 5px;cursor: pointer;" src="../../../assets/img/account/angle.png" @click="isQr = !isQr" />
            <img style="width: 169px;height:36px;margin-top: 66px;" src="../../../assets/img/account/logo.png" />
            <div style="display:flex;justify-content: space-around;font-size:20px;font-weight: 400;margin-top: 42px;width: 100%;">
              <p style="cursor: pointer;" @click="
                loginMode = 'password';
              qrText = null;
              " :style="{ color: loginMode == 'password' ? '#303133' : '#909399' }">
                {{ $t("mimadenglu") }}
              </p>
              <p style="cursor: pointer;" @click="
                loginMode = 'scan';
              getLoginQRCode();
              " :style="{ color: loginMode == 'scan' ? '#303133' : '#909399' }">
                {{ $t("saomadenglu") }}
              </p>
            </div>
            <el-form v-show="loginMode == 'password'" style="width: 100%;margin-top: 42px;" size="small" ref="form" :model="form">
              <el-form-item>
                <el-input :prefix-icon="'el-icon-user'" v-model="form.username" :placeholder="$t('yonghuming')"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input :prefix-icon="'el-icon-lock'" v-model="form.password" type="password" :placeholder="$t('mima')"></el-input>
              </el-form-item>
              <el-form-item>
                <div style="display:flex;justify-content:space-between">
                  <el-checkbox @change="changeIsFillUsername" :label="$t('jizhuzhanghao')" v-model="form.isFillUsername" name="type"></el-checkbox>
                  <el-checkbox :disabled="!form.isFillUsername" :label="$t('jizhumima')" v-model="form.isFillPassword" name="type"></el-checkbox>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button style="width: 100%;height: 50px;font-size: 16px;" type="primary" :loading="loading" @click="login">
                  {{ $t("denglu") }}
                </el-button>
              </el-form-item>
            </el-form>
            <div v-show="loginMode == 'scan'" style="text-align: center;">
              <div style="padding:20px;border:1px soild #DCDFE6;text-align: center;">
                <vue-qr v-if="qrText != null && qrTips != 'yisaoma,dengdaiquerendenglu'" :text="qrText" :size="240"></vue-qr>
              </div>
              <p style="font-size: 16px;font-weight: bold">{{ $t(qrTips) }}</p>
            </div>
          </div>
          <div v-show="isQr" style="padding: 20px;box-sizing: border-box;">
            <div style="width: 100%;display: flex;justify-content: flex-end;">
              <el-button style="padding: 0;" @click="isQr = !isQr" icon="yicon yicon-login" type="text">
                {{ " " + $t("fanhuidenglu") }}
              </el-button>
            </div>

            <div style="display: flex;justify-content:center;padding: 0 33px;align-items: center;margin-top: 28px;">
              <img style="width: 120px;height:120px;margin-right: 30px;" src="../../../assets/img/account/app_code.png" />
              <p style="word-break: break-all;width: 130px;">{{ $t("saomaxiazaishoujikehuduan") }}</p>
            </div>
            <div style="display: flex;justify-content:center;padding: 0 33px;align-items: center;margin-top: 28px;">
              <img style="width: 120px;height:120px;margin-right: 30px;" src="../../../assets/img/account/mp_code.png" />
              <p style="word-break: break-all;width: 130px;">
                {{ $t("yizhimigongyehulianwangweixingongzhonghao") }}
              </p>
            </div>
            <div style="display: flex;justify-content:center;padding: 0 33px;align-items: center;margin-top: 28px;">
              <img style="width: 120px;height:120px;margin-right: 30px;" src="../../../assets/img/account/mini_code.jpg" />
              <p style="word-break: break-all;width: 130px;">{{ $t("yi+zhizaopingtaixiaochengxu") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import VueQr from "vue-qr";
import JsEncrypt from "jsencrypt";
import Yi_card_reader from "@/common/yi_card_reader/yi_card_reader.vue";
export default {
  name: "other_account_login",
  components: {
    Yi_card_reader,
    VueQr,
  },
  data() {
    return {
      cardTimer: null,
      loginMode: "password",
      isQr: false,
      loading: false,
      contentHeight: 0,
      form: {
        username: "",
        password: "",
        isFillUsername: false,
        isFillPassword: false,
      },
      height: "0px",
      lang: localStorage.getItem("lang"),
      isFullscreen: false,
      qrText: null,
      qrTimer: null,
      qrTips: "",
    };
  },
  created() {
    if (this.$route.query.token != null && this.$route.query.token != "") {
      window.localStorage.setItem("token", this.$route.query.token);
      window.location.href = "/";
      return;
    }

    if (this.$route.query.code != null && this.$route.query.code != "" && this.$route.query.type != "" && this.$route.query.type != "") {
      this.loginByCode()
      return;
    }

    this.initWsr();
    this.$nextTick(() => {
      document.title = this.$t("登录") + " - 伊之密工业互联网平台";
    });

    //取回账号密码
    let isFillUsername = window.localStorage.getItem("isFillUsername");
    let isFillPassword = window.localStorage.getItem("isFillPassword");
    let fillPassword = window.localStorage.getItem("fillPassword");
    let fillUsername = window.localStorage.getItem("fillUsername");

    if (isFillUsername == "true") {
      this.form.username = fillUsername;
      this.form.isFillUsername = true;
    } else {
      this.form.username = "";
      this.form.isFillUsername = false;
    }

    if (isFillPassword == "true") {
      this.form.password = fillPassword;
      this.form.isFillPassword = true;
    } else {
      this.form.password = "";
      this.form.isFillPassword = false;
    }

    window.addEventListener("resize", () => { });
    window.addEventListener("keydown", () => {
      if (event.keyCode === 13) {
        //如果当前页面存在yi_card_reader组件,则屏蔽回车
        if (this.$refs.cardReader == null) {
          this.login();
        }
      }
    });
    this.qrTimer = setInterval(() => {
      this.isLoginQRCodeUsed();
    }, 2000);
  },
  destroyed() {
    if (this.cardTimer) {
      clearInterval(this.cardTimer);
    }
    window.removeEventListener("keydown");
    window.removeEventListener("resize");
    clearInterval(this.qrTimer);
  },
  mounted() {
    this.store.state.router_tabs = [];
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  methods: {
    resize() {
      this.$nextTick(() => {
        this.height = window.innerHeight + "px";
        this.contentHeight = window.innerHeight - this.$refs.header.offsetHeight + "px";
      });
    },
    changeLocale(e) {
      let locale = this.i18n.locale;
      this.i18n.locale = ["zh_CN", "en_US", "de_DE"][e];
      localStorage.setItem("lang", ["zh_CN", "en_US", "de_DE"][e]);
      window.location.href = "/";
    },
    fullScreen(el) {
      this.isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      if (!this.isFullscreen) {
        //进入全屏,多重短路表达式
        (el.requestFullscreen && el.requestFullscreen()) || (el.mozRequestFullScreen && el.mozRequestFullScreen()) || (el.webkitRequestFullscreen && el.webkitRequestFullscreen()) || (el.msRequestFullscreen && el.msRequestFullscreen());
      } else {
        //退出全屏,三目运算符
        document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : "";
      }
    },
    toggleFullScreen(e) {
      var el = document.documentElement;
      this.fullScreen(el);
      setTimeout(() => {
        this.height = window.innerHeight + "px";
      }, 100);
    },
    changeIsFillUsername(e) {
      if (e == false) {
        this.form.isFillPassword = false;
      }
    },
    login() {
      this.loading = true;
      this.http
        .get("web/auth/rsa")
        .then((res) => {
          let pubKey = `-----BEGIN PUBLIC KEY-----
					${res.data.publicKey}
					 -----END PUBLIC KEY-----`;
          const jse = new JsEncrypt();
          jse.setPublicKey(pubKey);
          let params = {
            username: this.form.username.trim(),
            encryptedPassword: jse.encrypt(this.form.password.toString()),
            rsaSecret: res.data.secret,
          };
          this.http
            .post("/web/auth/login", params)
            .then((res2) => {
              window.localStorage.setItem('ssoToken', res2.data.fineToken);
              window.localStorage.setItem("token", res2.data.token);
              //记住账号密码
              if (this.form.isFillUsername == true) {
                window.localStorage.setItem("isFillUsername", true);
                window.localStorage.setItem("fillUsername", this.form.username);
              } else {
                window.localStorage.setItem("isFillUsername", false);
                window.localStorage.setItem("fillUsername", "");
              }
              if (this.form.isFillPassword == true) {
                window.localStorage.setItem("isFillPassword", true);
                window.localStorage.setItem("fillPassword", this.form.password);
              } else {
                window.localStorage.setItem("isFillPassword", false);
                window.localStorage.setItem("fillPassword", "");
              }

              this.loading = false;
              window.location.href = "/";
            })
            .catch((err) => {
              this.loading = false;
              this.utils.errorMessage(err);
            });
        })
        .catch((err) => {
          this.loading = false;
          this.utils.errorMessage(err);
        });
    },
    loginByCode() {
      this.loading = true;
      let params = {
        code: this.$route.query.code,
        type: this.$route.query.type,
      };
      this.http
        .post("/web/auth/loginByCode", params)
        .then((res) => {
          window.localStorage.setItem('ssoToken', res.data.fineToken);
          window.localStorage.setItem("token", res.data.token);
          this.loading = false;
          window.location.href = "/";
        })
        .catch((err) => {
          this.loading = false;
          this.utils.errorMessage(err);
        });
    },
    loginByQRCode() {
      this.loading = true;
      let params = {
        code: this.qrText,
      };
      this.http
        .get("/web/auth/loginByQRCode", {
          params: params,
        })
        .then((res) => {
          window.localStorage.setItem("token", res.data.token);
          this.loading = false;
          window.location.href = "/";
        })
        .catch((err) => {
          this.loading = false;
          this.utils.errorMessage(err);
        });
    },
    //1
    isLoginQRCodeUsed() {
      if (this.qrText == null) {
        return;
      }
      let params = {
        code: this.qrText,
      };
      this.http
        .get("web/auth/isLoginQRCodeUsed", {
          params: params,
        })
        .then((res) => {
          if (res.data == 0) {
            this.qrTips = "dianjiyipingtaiappshouyeyoushangjiaotubiao,saoyisaoanquandenglu";
          } else if (res.data == 1) {
            this.qrTips = "yisaoma,dengdaiquerendenglu";
          } else if (res.data == 2) {
            //确认
            this.loginByQRCode();
          } else if (res.data == 3) {
            //过期
            this.getLoginQRCode();
          }
        })
        .catch((err) => { });
    },
    getLoginQRCode() {
      let params = {
        type: 0,
      };
      this.http
        .get("web/auth/getLoginQRCode", {
          params: params,
        })
        .then((res) => {
          this.qrText = res.data;
        })
        .catch((err) => {
          this.utils.errorMessage(err);
        });
    },
    initWsr() {
      //初始化卡机
      var wsr = wsrProxy;
      // 初始化 wsrProxy
      wsr.init();
      //打开刷卡端口
      let port = 0; //端口
      let block = 1; //区块1
      let key = "FFFFFFFFFFFF"; // 卡密码
      let keytype = 0; //密码A
      //打开端口
      let ret = wsr.ws_openPort(port);
      let card = {
        cardno: "",
        uid: "",
        len: 0,
      }; // 卡号为 字符串 string
      let preCardNo = "";
      let data = {
        data: "",
      };
      let data2 = {
        data: "",
      };

      if (ret >= 0) {
        //开启读卡定时器
        this.cardTimer = setInterval(() => {
          //正在请求就不读了
          if (this.loading) {
            return;
          }
          ret = wsr.ws_getCardNo_String(port, card);
          if (ret < 0) {
            preCardNo = "";
            return;
          }

          if (card.cardno == preCardNo) {
            return;
          }
          preCardNo = card.cardno;

          ret = wsr.ws_verifyKey(port, key, keytype, block);
          if (ret < 0) {
            console.log("验证密码失败！");
            return;
          }

          ret = wsr.ws_readBlock(port, 4, data);
          if (ret < 0) {
            console.log("读取cardUid数据失败");
            return;
          }

          ret = wsr.ws_readBlock(port, 5, data2);
          if (ret < 0) {
            console.log("读取Secret数据失败");
            return;
          }

          ret = wsr.ws_beep(port);

          this.getToken(data.data, data2.data, card.cardno);
        }, 500);
      } else {
        console.log("打开卡机端口失败");
        // alert("打开卡机端口失败！")
      }
    },
    getToken(cardUid, secret, no) {
      this.loading = true;

      var params = {
        uid: cardUid,
        secret: secret,
        no: no,
      };
      this.http
        .post("/web/auth/icCardLogin", params)
        .then((result) => {
          window.localStorage.setItem("token", result.data.token);
          this.loading = false;
          window.location.href = "/";
        })
        .catch((error) => {
          this.loading = false;
          this.utils.errorMessage(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cardReaded(no) {
      this.http.post('/web/auth/icCardCommonLogin', { no: no }).then((res) => {
        window.localStorage.setItem("token", res.data.token);
        window.location.href = "/";
      }).catch((err) => {
      }).finally(() => {
      });
    },
  },
};
</script>
